import { CrewConstants } from './crew.constants'
import { ICrewMember, ICrewState, IPCRCrewMember } from './crew.types'
import { randomNumber } from '../../../utilities'

export const crewInit = (): ICrewMember => {
  return {
    key: randomNumber().toString(),
    userId: null,
    certificationLevelId: '',
    roleId: [],
    roleIdPNNV: null,
    preceptorStudent: null,
  }
}

export const pcrCrewInit = (): IPCRCrewMember => {
  return {
    crewId: 1,
    user: {},
    roles: [],
    rolesPNNV: null,
    preceptorStudent: null,
  }
}

export const initialCrewState: ICrewState = {
  shift: null,
  base: null,
  staffingLevel: null,
  vehicle: null,
  vehicleOptions: [],
  registrationTailNumber: null,
  unitEquipment: null,
  primaryMonitor: null,
  primaryMonitorOptions: [],
  crewMember: null,
  userId: null,
  certificationLevelId: '',
  roleId: [],
  preceptorStudent: null,
  preceptorStudentOptions: [],
  roleOptions: [],
  crewList: [crewInit()],
  pcrCrew: [pcrCrewInit()],
  crewListData: [],
  isLoading: true,
  shiftOptions: [],
  baseOptions: [],
  staffingLevelOptions: [],
  unitEquipmentOptions: [],
  registrationTailOptions: [],
  crewLicensuresOptions: [],
}

export function crewReducer(state: ICrewState = initialCrewState, action: any): ICrewState {
  switch (action.type) {
    case CrewConstants.SET_SHIFT:
      return { ...state, shift: action.shift }
    case CrewConstants.SET_SHIFT_OPTIONS:
      return { ...state, shiftOptions: action.shiftOptions }
    case CrewConstants.SET_BASE:
      return { ...state, base: action.base }
    case CrewConstants.SET_BASE_OPTIONS:
      return { ...state, baseOptions: action.baseOptions }
    case CrewConstants.SET_STAFFING_LEVEL:
      return { ...state, staffingLevel: action.staffingLevel }
    case CrewConstants.SET_STAFFING_LEVEL_OPTIONS:
      return { ...state, staffingLevelOptions: action.staffingLevelOptions }
    case CrewConstants.SET_VEHICLE:
      return { ...state, vehicle: action.vehicle }
    case CrewConstants.SET_VEHICLE_OPTIONS:
      return { ...state, vehicleOptions: action.vehicleOptions }
    case CrewConstants.SET_REGISTRATION_TAIL_NUMBER:
      return { ...state, registrationTailNumber: action.registrationTailNumber }
    case CrewConstants.SET_REGISTRATION_TAIL_NUMBER_OPTIONS:
      return { ...state, registrationTailOptions: action.registrationTailOptions }
    case CrewConstants.SET_UNIT_EQUIPMENT:
      return { ...state, unitEquipment: action.unitEquipment }
    case CrewConstants.SET_UNIT_EQUIPMENT_OPTIONS:
      return { ...state, unitEquipmentOptions: action.unitEquipmentOptions }
    case CrewConstants.SET_PRIMARY_MONITOR:
      return { ...state, primaryMonitor: action.primaryMonitor }
    case CrewConstants.SET_PRIMARY_MONITOR_OPTIONS:
      return { ...state, primaryMonitorOptions: action.primaryMonitorOptions }
    case CrewConstants.SET_NAME:
      return { ...state, crewMember: action.crewMember, userId: action.userId }
    case CrewConstants.SET_CERTIFICATION_LEVEL:
      return { ...state, crewMember: action.crewMember, certificationLevelId: action.certificationLevelId }
    case CrewConstants.SET_ROLE:
      return { ...state, crewMember: action.crewMember, roleId: action.roleId }
    case CrewConstants.SET_ROLE_PNNV:
      return { ...state, crewMember: action.crewMember, roleIdPNNV: action.roleIdPNNV }
    case CrewConstants.SET_PRECEPTOR_STUDENT:
      return {
        ...state,
        crewMember: action.crewMember,
        preceptorStudent: action.preceptorStudent,
      }
    case CrewConstants.SET_ROLE_OPTIONS:
      return { ...state, roleOptions: action.roleOptions }
    case CrewConstants.SET_PRECEPTOR_STUDENT_OPTIONS:
      return { ...state, preceptorStudentOptions: action.preceptorStudentOptions }
    case CrewConstants.ON_ADD_CREW_MEMBER:
      return { ...state, crewList: [...state.crewList, crewInit()] }
    case CrewConstants.SET_CREW_LIST:
      return { ...state, crewList: action.crewList }
    case CrewConstants.SET_PCR_CREW:
      return { ...state, pcrCrew: action.pcrCrew }
    case CrewConstants.SET_CREW_LIST_DATA:
      return { ...state, crewListData: action.crewListData, isLoading: false }
    case CrewConstants.SET_CREW_LICENSURES_OPTIONS:
      return { ...state, crewLicensuresOptions: action.crewLicensuresOptions }
    case CrewConstants.RESET_SHIFT_STARTUP:
      return {
        ...state,
        shift: null,
        base: null,
        staffingLevel: null,
        vehicle: null,
        primaryMonitor: null,
        crewList: [crewInit()],
        pcrCrew: [pcrCrewInit()],
        registrationTailNumber: null,
      }
    default:
      return state
  }
}
